module.exports = "/_next/static/images/8b5e4e0a91e020615c6741f000816e92-roxinho-single-lg@3x.jpg.webp";